import taskManagerApi from '@/features/shared/services/taskManagerApi';
const API_ROUTE = '/parametre';
const extractErrorMessage = (error) => {
    if (error instanceof Error) {
        const serverError = error?.response?.data?.error;
        if (serverError) {
            const details = Array.isArray(serverError.details)
                ? serverError.details.join(' ')
                : serverError.details;
            return details ?? serverError.message ?? error.message;
        }
        return error.message;
    }
    return 'Une erreur inattendue est survenue.';
};
export const fetchParameters = async (page = 1, filters = {}, all = false, limit = 10) => {
    try {
        const params = {
            ...(page ? { page } : {}),
            ...(limit ? { limit } : {}),
            ...(filters.cle ? { cle: filters.cle } : {}),
            ...(filters.type_param ? { type_param: filters.type_param } : {}),
            ...(all ? { all: true } : {}),
        };
        const response = await taskManagerApi.get(API_ROUTE, { params });
        return response.data.data;
    }
    catch (error) {
        throw new Error(extractErrorMessage(error));
    }
};
export const createParameter = async (parameter) => {
    try {
        const response = await taskManagerApi.post(API_ROUTE, parameter);
        return response.data.data?.parametre;
    }
    catch (error) {
        throw new Error(extractErrorMessage(error));
    }
};
export const updateParameter = async ({ id, parameter }) => {
    try {
        await taskManagerApi.put(`${API_ROUTE}/${id}`, parameter);
    }
    catch (error) {
        throw new Error(extractErrorMessage(error));
    }
};
export const deleteParameter = async (id) => {
    try {
        await taskManagerApi.delete(`${API_ROUTE}/${id}`);
    }
    catch (error) {
        throw new Error(extractErrorMessage(error));
    }
};
export const fetchParameterValue = async (key) => {
    try {
        const { parametres } = await fetchParameters(1, { cle: key }, false, 1);
        return parametres?.[0]?.valeur ?? null;
    }
    catch (error) {
        throw new Error(extractErrorMessage(error));
    }
};
